import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import FileUpload from 'src/components/ui/FileUpload/FileUpload';
import NoResultsFound from 'src/components/ui/NoResultsFound/NoResultsFound';
import { SaleOrder } from 'src/services/saleOrder';
import styles from './Attachments.module.scss';
import { Attachment } from '../../Chat/Attachment';

export interface AttachmentsProps {
  attachments?: any[];
  edit?: boolean;
  updateAttachments: (attachments: any[]) => void;
  entity?: SaleOrder;
}

const Attachments: React.FC<AttachmentsProps> = ({ attachments = [], edit, updateAttachments, entity }) => {
  const { t } = useTranslation();

  const handleAttachmentChange = (files: any[]) => {
    const formattedAttachments = files.map(item => ({
      file: item.file,
      mimetype: item.mimetype,
      name: item.name,
    }));

    if (entity) {
      // For sale order backward compatibility
      updateAttachments(formattedAttachments);
    } else {
      // For case overlay
      updateAttachments(formattedAttachments);
    }
  };

  const renderAttachmentBlock = () => {
    if (edit) {
      return (
        <FileUpload disabled={!edit} defaultFiles={attachments} onChange={handleAttachmentChange} hideDeleteButton />
      );
    }

    if (attachments?.length) {
      return (
        <div className="grid grid-cols-2 gap-[16px]">
          {attachments.map((file: any) => (
            <div key={file.name} className="flex w-full">
              <Attachment attachment={file} t={t} />
            </div>
          ))}
        </div>
      );
    }

    return (
      <div className="w-full">
        <NoResultsFound smallTitle title={t('general.no_attachments')} />
      </div>
    );
  };

  return (
    <div className={classNames(styles.root)}>
      <div className={classNames(styles.info)}>
        <span className="typo-text-14--bold text-faded">{t('general.attachments')}</span>
        {renderAttachmentBlock()}
      </div>
    </div>
  );
};

export default Attachments;
